import { getServerDateTime } from '../../../../../../shared/helpers/WVFormatter';

export default ({ record }) => {
  const { uploadDatetime } = record.params;
  return uploadDatetime ? getServerDateTime(uploadDatetime, 'M/D/YYYY h:mma') : '';
};
